module.exports = __webpack_public_path__ + "img/MEDIA090.4586e221.jpg";